import { useEffect, useRef, useContext } from "react";
import MediaSourcePlayer from "../../utils/video/MediaSourcePlayer";
import { VideoContext } from "../../contexts/VideoContext";
import { useNavigate } from "react-router";

export default function MediaBackground() {
	const { videoManagerRef } = useContext(VideoContext);
	const navigate = useNavigate();
	const videoElementRef = useRef<HTMLVideoElement | null>(null);
	const imageElementRef = useRef<HTMLImageElement | null>(null);

	useEffect(() => {
		if (!videoElementRef.current || !imageElementRef.current || videoManagerRef.current) return;
		videoManagerRef.current = new MediaSourcePlayer(
			videoElementRef.current,
			imageElementRef.current,
			navigate,
		);
	}, []);

	return (
		<>
			<img
				style={{
					height: "100%",
					width: "100%",
					position: "absolute",
					top: 0,
					left: 0,
					display: "none",
				}}
				className="z-10"
				ref={imageElementRef}
			/>
			<video
				autoPlay
				ref={videoElementRef}
				loop
				muted
				playsInline
				crossOrigin="anonymous"
				className="h-full w-full object-contain z-0"
			>
				Your browser does not support the video tag.
			</video>
		</>
	);
}
